import { Boolean, Intersect, Partial, Record, Static, String } from "runtypes";
import { UserRunType,UserEmailType } from "./IUser";

export const LoginCallbackResponseRuntype = Intersect(
  Record({
    user: UserRunType,
    data: UserEmailType,
  }),
  Partial({
    status: Boolean,
    message: String,
  })
);

export interface ILoginCallbackResponse
  extends Static<typeof LoginCallbackResponseRuntype> {}




// WEBPACK FOOTER //
// ./src/services/ILoginCallbackResponse.ts